<template>
  <div class="content has-text-centered">
    <a
      :href="'/' + Language + '/'"
      class="top_logo"
    ><img src="../../assets/img/eurotrader_logo_rgb_purple.svg" /></a>
    <div class="bg"></div>
    <div
      id="forgotPasswordFormContainer"
      class="columns is-vcentered"
    >
      <div class="column is-6 is-offset-3">
        <div class="box">
          <!-- <img src="../../assets/img/eurotrader_logo_rgb_white.svg" /> -->
          <h1 class="is-title is-bold"><span>{{$t("forgot").tUpper()}}</span><br />{{$t("password").tUpper()}}</h1>
          <div
            id="forgotPwInfo"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{$t("forgot_password_q").tTitle()}} {{$t("forgot_password_form_instruction").tTitle()}}</div>
          <form
            v-on:submit.prevent="validateCaptcha"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <label
              :class="{'float-right': Language == 'fa' || Language == 'ar'}"
              class="label"
            >{{$t("email").tTitle()}}*</label>
            <p class="control">
              <input
                v-model="data.body.email"
                class="input"
                type="text"
                placeholder="email@example.org"
              />
            </p>

            <p class="control">
              <button
                type="submit"
                class="button is-primary login"
              >{{$t("submit").tUpper()}}</button>
            </p>

            <div class="is-center">
              <span class="select is-small lang">
                <language />
              </span>
              <a
                class="is-small"
                href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf"
                target="_blank"
              >{{$t("risk_disclosure").tTitle()}}</a>
            </div>
            <div class="is-clearfix"></div>
          </form>
        </div>
      </div>
    </div>

    <error-modal></error-modal>
  </div>
</template>

<script>
import { service } from '../../app'
import config from '../../config'
import { mapGetters, mapActions } from 'vuex'
import ErrorModal from '../../components/ErrorModal'
import Language from '../../components/Language'

export default {
  components: {
    ErrorModal,
    Language,
  },
  data() {
    return {
      data: {
        body: {
          email: null,
          recaptchaToken: null
        },
      },
      error: null,
    }
  },
  computed: {
    websiteURL() {
      return config.URL.website
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', this.$t('forgot_password').tCapitalizeFirstLetter(), null)
    this.data.body.email = ''

    if (this.$auth.check()) {
      this.$router.push('/' + (this.Language || 'en') + '/' + config.defaultURL)
    }
  },
  methods: {
    validateCaptcha() {
      this.$recaptchaLoaded()
      this.recaptchaToken = this.$recaptcha('login')

      this.recaptchaToken.then(value => {
        this.sendResetPasswordLink(value)
      }).catch(err => {
        console.log(err)
      })
    },
    sendResetPasswordLink(token) {
      if (this.data.body.email !== '') {
        service
          .post('/users/forgot-password?isClient=1', {
            email: this.data.body.email.trim(),
            recaptchaToken: token
          })
          .then(response => {
            if (response.data.success) {
              this.$toasted.success(this.$t('forgot_password_submit_success_message', { email: this.data.body.email }).tTitle())
            } else {
              if (typeof response.data.messageID !== 'undefined') {
                this['errorModal/set']({ active: true, text: this.$t(response.data.messageID).tTitle() })
              }
            }
            this.data.body.email = ''
          })
          .catch(() => {
            this['errorModal/set']({ active: true, text: this.$t('internal_error') })
          })
      } else {
        this['errorModal/set']({ active: true, text: this.$t('please_enter_your_email') })
      }
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },

  filters: {
    json: function (value) {
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';
@import '../../assets/css/fa';

.bg {
  width: 100%;
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  // background-image: url('../../assets/img/big-bg.jpg');
  background-image: url('../../assets/img/bg-et-clientarea1.png');
  background-size: cover;
}

.top_logo {
  position: absolute;
  top: 27px;
  left: 42px;
  width: 176px;
  height: 27px;
  img {
    height: 27px;
    width: 100%;
  }
}

#forgotPasswordFormContainer {
  margin-top: calc(33vh - 225px);
}
.box {
  padding: 40px 40px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 0px;
  background: #6826f4 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 20px #0000001a;
  background-color: #6826f4;
  div#forgotPwInfo {
    color: #ccc;
    margin-bottom: 40px;
    text-align: center;
    font: normal normal 300 16px/24px Roboto;
    letter-spacing: 0px;
  }

  padding: 30px 40px;
  > img {
    width: 300px;
  }
  background-color: $secondary;
  h1 {
    color: #fff;
    margin: 30px 0 40px 0;
    font-size: 44px;
    font-weight: 900;
    line-height: 0.85;
    font-family: 'Roboto', sans-serif;
    white-space: break-spaces;
    span {
      color: #e04ef8;
    }
  }
  form {
    padding: 0 20px;
    h4 {
      color: #fff;
      font-size: 18px;
    }
    a:hover {
      color: #fff;
    }
    a.forgotPassword {
      float: left;
      margin: -10px 0 20px;
      font-size: 14px;
    }
    label {
      text-align: left;
      font-size: 16px;
      color: #fff;
      height: 26px;
      font-weight: 300;
      margin-bottom: 0;
      font-family: 'Roboto', sans-serif;
    }
    input {
      height: 46px;
      font-size: 18px;
      font-weight: 300;
      margin-bottom: 15px;
    }
    .columns.regButtons {
      margin-bottom: -10px;
    }
    .button {
      font-size: 12px;
      font-weight: 600;
      max-width: 152px;
      height: 40px;
      background-color: #3bed83;
      border-radius: 23px;
      color: #10182a;
      margin: 0 auto;
      display: table;
    }
    .button.login,
    .button.reg {
      font-family: $family-condensed;
      font-weight: 700;
      width: 100%;
      &.is-black {
        background-color: #000;
        border: 1px solid #f0f0f0;
      }
    }
    .select.lang {
      color: white;
      select {
        background-color: #6826f4;
        color: white;
        border: none;
        outline: none;
      }
      &::after {
        top: 47%;
        border-color: white;
      }
      // &:after {
      // 	border-color:#fff;
      // }
    }
    a.is-small {
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?1ae9bb39